import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ProviderService } from '../../services/provider/provider.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProviderResolve implements Resolve<any> {

    constructor(private ps: ProviderService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.ps.allProviders().pipe(map(providers => providers)).pipe(first());
    }

}
